import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';
import axiosInstance from '../utils/axiosInstance';
import { plotlyStyle } from '../utils/plotlyStyle';
import { Typography } from '@mui/material';
import { MESSAGES } from '../constants/messages';

const ChartIndustryWiseClientCount = () => {
  const [industryData, setIndustryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIndustryData = async () => {
      try {
        const res = await axiosInstance.get(
          '/chart/industry-wise-client-count'
        );

        setIndustryData(res.data);
        setError(null);
      } catch (err) {
        setError('データの取得に失敗しました');
      } finally {
        setLoading(false);
      }
    };

    fetchIndustryData();
  }, []);

  if (loading) {
    return (
      <Typography>
        {MESSAGES.LOADING}
      </Typography>
    );
  }

  if (error) {
    return (
      <Typography>
        {error || MESSAGES.LOAD_FAILED}
      </Typography>
    );
  }

  const industryPlotData = {
    x: industryData.map(
      item => item.industry_name
    ),

    y: industryData.map(item =>
      Number(item.client_count)
    ),

    type: 'bar',

    name: '顧客数',

    marker: {
      color: plotlyStyle.colors.bar,
    },

    hovertemplate:
      '業種: %{x}<br>' +
      '顧客数: %{y:,.0f}件' +
      '<extra></extra>',
  };

  const industryLayout = {
    ...plotlyStyle.layout,

    title: {
      text: '業種別顧客数',
    },

    margin: {
      t: 80,
      b: 150,
      l: 60,
      r: 60,
    },

    xaxis: {
      ...plotlyStyle.layout.xaxis,
      title: {
        text: '業種',
      },
    },

    yaxis: {
      ...plotlyStyle.layout.yaxis,

      title: {
        text: '顧客数',
      },

      tickformat: ',.0f',
    },
  };

  return (
    <Plot
      data={[industryPlotData]}
      layout={industryLayout}
      style={{
        width: '100%',
        height: '100%',
        minHeight: 500,
      }}
      useResizeHandler
      config={{
        responsive: true,
        displayModeBar: false,
      }}
    />
  );
};

export default ChartIndustryWiseClientCount;